import { PageWithRightPane } from "../../frameworks/joy/layouts/page_with_right_pane";
import { EngineHistoryContainer } from "./container";

export const EngineHistoryPage = () => {
  return (
    <PageWithRightPane>
      <EngineHistoryContainer />
    </PageWithRightPane>
  );
};
